module.exports = __webpack_public_path__ + "assets/img/Rules.99519691.png";